// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M2.3 4V13.5',
  'M5.5 2.5V13.5',
  'M8.7 3.5V13.5',
  'M11 3.7L13.45 13.5',
];
